import { useCallback, useEffect } from 'react';

import { NuveiAPM } from './components/NuveiAPM/NuveiAPM';
import { useCheckout } from '../../../../hooks/use-checkout';
import { EBEPaymentMethodsName } from '../../../../contracts';
import { usePaymentState } from '../../hooks/use-payment-state';
import { NuveiCardContainer } from './components/NuveiCardContainer/NuveiCardContainer';
import { apmLatencyTracker } from '../../../../utils/apm-latency-tracker';

export function NuveiPayment() {
  const { selectedPaymentMethod } = useCheckout();
  const setIsApmLoading = usePaymentState((state) => state.setIsApmLoading);
  const setIsPaymentElementLoading = usePaymentState((state) => state.setIsPaymentElementLoading);

  const isCard = selectedPaymentMethod?.pspPaymentMethodName === EBEPaymentMethodsName.cardNuvei;

  useEffect(() => {
    try {
      apmLatencyTracker.startTracking('Nuvei', selectedPaymentMethod?.id);
    } catch (error) {
      console.error('Failed to start APM latency tracking:', error);
    }
  }, [selectedPaymentMethod?.id]);

  const onReady = useCallback(() => {
    setIsPaymentElementLoading(false);
    setIsApmLoading(false);

    try {
      apmLatencyTracker.endTracking('Nuvei', selectedPaymentMethod?.id, {
        paymentMethodName: selectedPaymentMethod?.paymentMethodName,
        paymentMethodDisplayName: selectedPaymentMethod?.paymentMethodDisplayName,
        provider: 'Nuvei',
        isCard,
      });
    } catch (error) {
      console.error('Failed to end APM latency tracking:', error);
    }
  }, [setIsPaymentElementLoading, setIsApmLoading, selectedPaymentMethod, isCard]);

  if (isCard) {
    return <NuveiCardContainer onReady={onReady} />;
  }
  return <NuveiAPM onReady={onReady} />;
}
